import React from 'react';
import Modal from 'react-bootstrap/Modal';
import './Animation/success.json';
import Success from '../../../RecruiterPage/Model/Animation/Success.js';
import "./ThirdJobTabModal.css"

function ThirdJobTabModal(props) {
    
    return (  
      <>     
        <div >
          <Modal
            {...props} className='main-modal'
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
  
            <Modal.Body>
              <Success />
              <p className='modal_txt text-center'> Recruiter has been Notified!</p>
              <p className='text-center' style={{ color: "#FFFF" }}> Have a Great Time! </p>
            </Modal.Body>
  
          </Modal>
  
        </div>
      </>
      
    );
  }
  
  export default ThirdJobTabModal;
  